// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#reset-password {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#reset-password-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  width: 100%;
}
#reset-password-header h4 {
  margin: auto;
  color: var(--color-primary);
}

#reset-password-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  row-gap: 10px;
  height: 100%;
  padding: 25px 0;
}

#reset-password-form {
  display: flex;
  flex-direction: column;
  width: 90%;
  row-gap: 10px;
}

#reset-pass-btn {
  width: max(30%, 300px);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login/forgotten-password/reset-password/reset-password.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACJ;AAAI;EACI,YAAA;EACA,2BAAA;AAER;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;AACJ;;AAEA;EACI,sBAAA;AACJ","sourcesContent":["#reset-password {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n#reset-password-header {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    background-color: white;\r\n    width: 100%;\r\n    h4 {\r\n        margin: auto;\r\n        color: var(--color-primary);\r\n    }\r\n}\r\n\r\n#reset-password-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    row-gap: 10px;\r\n    height: 100%;\r\n    padding: 25px 0;\r\n}\r\n\r\n#reset-password-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 90%;\r\n    row-gap: 10px;\r\n}\r\n\r\n#reset-pass-btn {\r\n    width: max(30%, 300px);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
